import { useExperimentTakeover } from 'modules/experiments/takeover';
import { CampaignStateDefinition } from 'modules/graphql';
import { SecondaryButton } from 'ui/button';
import { ExperimentFlask } from 'ui/icons';
import { RightTooltip } from 'ui/tooltip';
import { useLocalesContext } from 'utils/contexts/locales/localeSettings';

import { ButtonContentWrapper } from './ExperimentSection.styled';

export const EXPERIMENT_BUTTON = 'experiment-button';

const content = {
  buttonText: 'Create A/B experiment',
};

type NewExperimentButtonProps = {
  /** Campaign Id */
  campaignId?: number;
  /** Campaign Name */
  campaignName: string;
  /** Campaign State */
  campaignState?: CampaignStateDefinition;
  /** Is the campaign's delivery set to send time optimized */
  isCampaignSTOEnabled: boolean;
  /** Is the section disabled */
  isExperimentCreationDisabled?: boolean;
  /** Disabled tooltip text */
  tooltipText: string;
};

/** Returns button with a link or a disabled button depending on if the campaign exists or not */
export const NewExperimentButton: React.FC<React.PropsWithChildren<NewExperimentButtonProps>> = ({
  campaignId,
  campaignName,
  campaignState,
  isCampaignSTOEnabled,
  isExperimentCreationDisabled = false,
  tooltipText,
  children,
}) => {
  const { openExperimentCreationModal } = useExperimentTakeover();
  const { hasLocales } = useLocalesContext();

  return (
    <RightTooltip tooltipContent={tooltipText} isEnabled={isExperimentCreationDisabled}>
      <SecondaryButton
        data-test={EXPERIMENT_BUTTON}
        isDisabled={isExperimentCreationDisabled}
        onClick={() =>
          openExperimentCreationModal({
            id: campaignId,
            name: campaignName,
            campaignState,
            isCampaignSTOEnabled,
            hasLocales,
          })
        }
      >
        <ButtonContentWrapper>
          <ExperimentFlask />
          <span>{children || content.buttonText}</span>
        </ButtonContentWrapper>
      </SecondaryButton>
    </RightTooltip>
  );
};
